<template>
  <div class="d-flex" :class="this.$store.state.menuToggle" id="wrapper">
    <TheSidemenu />
    <div id="page-content-wrapper">
      <TheTopmenu />
      <div class="container-fluid p-1">
        <p class="fs-5 my-2 text-start ps-2">
          {{ this.$route.meta.title }}
        </p>
        <div v-if="!liveSessions">
          <i class="fas fa-spinner fa-spin fs-1 mt-3"></i>
        </div>
        <div v-else class="row g-0">
            <template v-for="item in liveSessions" :key="item.id">
              <div class="col-6 col-sm-12">
                <div
                  class="row g-0 bg-light m-1 m-sm-2 align-items-center rounded shadow"
                >
                  <div class="col-12 col-sm-1">
                    <img
                      class="w-100"
                      :src="API_STORAGE_URL + item.product.thumbnail"
                      @error="noPic"
                    />
                  </div>
                  <div
                    class="col-12 my-2 col-sm-4 fs-6 fw-bold text-decoration-none"
                  >
                    {{ item.product.name }} - جلسه {{ item.numName }}
                  </div>
                  <div class="col-12 my-2 col-sm-5 text-decoration-none">
                    تاریخ برگزاری:
                    <span>
                      {{
                        jmoment(item.videoSession.start_date).format(
                          "jYYYY/jMM/jDD"
                        )
                      }}
                      ,ساعت
                      {{ item.videoSession.start_time }} الی
                      {{ item.videoSession.end_time }}
                    </span>
                  </div>
                  <div class="col-12 col-sm-2 mb-2 mb-sm-0 p-2">
                    <router-link
                      v-if="item.price == 0"
                      :to="{
                        name: 'VideoSession',
                        params: {
                          videoSessionId: item.id,
                          productId: item.product.id,
                        },
                      }"
                      class="btn btn-sm btn-success d-block"
                    >
                      <i class="fas fa-gifts me-1"></i>
                      <span>ورود رایگان</span>
                    </router-link>

                    <router-link
                      v-else-if="item.buyed_before"
                      class="btn btn-sm btn-success d-block"
                      :to="{
                        name: 'VideoSession',
                        params: {
                          videoSessionId: item.id,
                          productId: item.product.id,
                        },
                      }"
                    >
                      <i class="fas fa-check me-1"></i>
                      <span>ورود به کلاس</span>
                    </router-link>

                    <a
                      v-else
                      @click="addToCart(item.id, item.product.id)"
                      class="btn btn-outline-primary btn-sm d-block"
                    >
                      <i class="fas fa-shopping-cart me-1"></i>
                      <span>افزودن به سبد خرید</span>
                      <i
                        :id="`progress-${item.id}`"
                        class="fas fa-spinner fa-spin d-none"
                      ></i>
                      <i
                        :id="`check-${item.id}`"
                        class="fas fa-check d-none"
                      ></i>
                    </a>
                  </div>
                </div>
              </div>
            </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheSidemenu from "../../components/TheSidemenu";
import TheTopmenu from "../../components/TheTopmenu";
import ArefApi from "../../libs/api.js";
import utils from "../../libs/utils";
import jmoment from "moment-jalaali";

export default {
  name: "SingleSessions",
  created() {
    this.arefApi = new ArefApi();
    this.utils = new utils();
    this.jmoment = jmoment;
    this.getLiveSessions();
  },
  components: {
    TheSidemenu,
    TheTopmenu,
  },
  data() {
    return {
      liveSessions: null,
      API_STORAGE_URL: process.env.VUE_APP_API_STORAGE_URL,
    };
  },
  methods: {
    getLiveSessions() {
      this.arefApi
        .getLiveSessions()
        .then((resp) => {
          let tmpLiveSessions = resp.data;
          tmpLiveSessions.sort((a,b) => {
            return a.videoSession.start_time > b.videoSession.start_time ? 1:-1;
          });
          this.liveSessions = tmpLiveSessions;
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        });
    },
    noPic(e) {
      e.target.src =
        process.env.VUE_APP_API_STORAGE_URL + process.env.VUE_APP_NO_IMAGE_URL;
    },
    addToCart(product_details_id, productId) {
      const obj = {
        products_id: productId,
        product_details_id,
      };
      document
        .querySelector(`#progress-${product_details_id}`)
        .classList.remove(`d-none`);
      this.arefApi
        .addMicroProductToCart(obj)
        .then((resp) => {
          document
            .querySelector(`#progress-${product_details_id}`)
            .classList.add(`d-none`);
          document
            .querySelector(`#check-${product_details_id}`)
            .classList.remove(`d-none`);
          this.$store.commit("set", [
            "cartCount",
            this.utils.getCartCount(resp.data),
          ]);

          this.$store.commit("set", ["cartAmount", resp.data.amount]);
          window.scrollTo(0,top);
        })
        .catch((err) => {
          if (err.data.errors.added_before) {
            this.utils.showSuccess(this, "کل محصول قبلا به سبد اضافه شده است");
          } else {
            this.utils.showErrors(this, err);
          }

          document
            .querySelector(`#progress-${product_details_id}`)
            .classList.add(`d-none`);
        });
    },
  },
};
</script>

